module.exports = __webpack_public_path__ + "static/media/belinvest-small.aa3764be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/belinvest-small.png
// module id = 497
// module chunks = 0